module.exports = __webpack_public_path__ + "img/45.1df9fb5c.jpg";